'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _clamp = require('./../utilities/clamp');

var _clamp2 = _interopRequireDefault(_clamp);

var _toHsla = require('./../conversionFunctions/toHsla');

var _toHsla2 = _interopRequireDefault(_toHsla);

var _toRgba = require('./../conversionFunctions/toRgba');

var _toRgba2 = _interopRequireDefault(_toRgba);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = function (color, amount) {
  var hsla = (0, _toHsla2.default)(color);
  hsla.saturation += amount;
  hsla.saturation = (0, _clamp2.default)(hsla.saturation, 0, 1);
  return (0, _toRgba2.default)(hsla);
};